// extracted by mini-css-extract-plugin
export default {"card":"style_card__uv+hH","subTitle":"style_subTitle__nobuK","image":"style_image__t8nyN","par":"style_par__C-iLg"};